module.exports = __webpack_public_path__ + "static/img/7.02ba4963.png";